// extracted by mini-css-extract-plugin
export var filterIncDec = "_c5-0";
export var leftBorder = "_c5-1";
export var rightBorder = "_c5-2";
export var stringInput = "_c5-3";